import { render, staticRenderFns } from "./RequestFundsFilter.vue?vue&type=template&id=636767c2&scoped=true"
import script from "./RequestFundsFilter.vue?vue&type=script&lang=js"
export * from "./RequestFundsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636767c2",
  null
  
)

export default component.exports